import React from "react";
import { Card, CardBody, Col, Placeholder, Row } from "reactstrap";

interface BookingCatalogSkeletonProps {
  count?: number;
}

const BookingCatalogSkeleton: React.FC<BookingCatalogSkeletonProps> = ({ count = 3 }) => (
  <Row className="g-3">
    {Array.from({ length: count }).map((_, index) => (
      <Col xs={12} key={`booking-catalog-skeleton-${index}`}>
        <Card className="border shadow-none mb-0">
          <CardBody>
            <div className="placeholder-glow">
              <Placeholder xs={7} className="rounded mb-2" />
              <Placeholder xs={4} className="rounded mb-2" />
              <Placeholder xs={3} className="rounded" />
            </div>
          </CardBody>
        </Card>
      </Col>
    ))}
  </Row>
);

export default BookingCatalogSkeleton;
